/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Description_Length_LabelInputs */

const en_ad_description_length_label = /** @type {(inputs: Ad_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description Length`)
};

const fr_ad_description_length_label = /** @type {(inputs: Ad_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description Longueur`)
};

const de_ad_description_length_label = /** @type {(inputs: Ad_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung Länge`)
};

const it_ad_description_length_label = /** @type {(inputs: Ad_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione Lunghezza`)
};

const ru_ad_description_length_label = /** @type {(inputs: Ad_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание Длина`)
};

const es_ad_description_length_label = /** @type {(inputs: Ad_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción Longitud`)
};

const zh_cn2_ad_description_length_label = /** @type {(inputs: Ad_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述长度`)
};

const ja_ad_description_length_label = /** @type {(inputs: Ad_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明の長さ`)
};

const hi_ad_description_length_label = /** @type {(inputs: Ad_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण लंबाई`)
};

const pt_pt2_ad_description_length_label = /** @type {(inputs: Ad_Description_Length_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição Comprimento`)
};

/**
* | output |
* | --- |
* | "Description Length" |
*
* @param {Ad_Description_Length_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_description_length_label = /** @type {((inputs?: Ad_Description_Length_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Description_Length_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_description_length_label(inputs)
	if (locale === "de") return de_ad_description_length_label(inputs)
	if (locale === "it") return it_ad_description_length_label(inputs)
	if (locale === "ru") return ru_ad_description_length_label(inputs)
	if (locale === "es") return es_ad_description_length_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_description_length_label(inputs)
	if (locale === "ja") return ja_ad_description_length_label(inputs)
	if (locale === "hi") return hi_ad_description_length_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_description_length_label(inputs)
	return en_ad_description_length_label(inputs)
});